module.exports = __webpack_public_path__ + "static/media/logos.c388fca3.png";